import type { CSSProperties, MouseEventHandler, ReactElement, ReactNode, RefObject, } from "react";
import { CtooltipContent } from "./CtooltipContent";
import { CtooltipMotion } from "./CtooltipMotion";
import { CtooltipText } from "./CtooltipText";
import { dataEl, type DataElScope } from "@/utils/dataEl";
interface CtooltipPositionerProps {
    dataElScope: DataElScope;
    body?: ReactNode;
    exitYOffset: number;
    onMouseEnter: MouseEventHandler<HTMLDivElement>;
    onMouseLeave: MouseEventHandler<HTMLDivElement>;
    positionerStyle: CSSProperties;
    title?: string;
    tooltipRef: RefObject<HTMLDivElement | null>;
}
export function CtooltipPositioner({ dataElScope, body, exitYOffset, onMouseEnter, onMouseLeave, positionerStyle, title, tooltipRef, }: CtooltipPositionerProps): ReactElement {
    return (
      <div data-el={dataEl(dataElScope, "Positioner/Root")} ref={tooltipRef} style={positionerStyle}>
        <CtooltipMotion dataElScope={dataElScope} exitYOffset={exitYOffset} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
          <CtooltipContent dataElScope={dataElScope}>
            <CtooltipText dataElScope={dataElScope} title={title} body={body}/>
          </CtooltipContent>
        </CtooltipMotion>
      </div>
    );
}
